import { Directive, input } from '@angular/core';
import { classes } from '@budgets/ui/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';

const alertVariants = cva(
  "grid gap-1 rounded border px-6 py-4 text-start text-body-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:[padding-inline-end:calc(var(--app-size-compact-control-height)+var(--app-space-6))] has-[>ng-icon]:grid-cols-[auto_1fr] has-[>ng-icon]:gap-x-4 *:[ng-icon]:row-span-2 *:[ng-icon]:mt-1 *:[ng-icon]:text-current *:[ng-icon:not([class*='text-'])]:text-body-base group/alert relative w-full",
  {
    variants: {
      variant: {
        default: 'bg-card text-card-foreground',
        destructive:
          'text-destructive bg-card *:data-[slot=alert-description]:text-destructive/90 *:[ng-icon]:text-current',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type AlertVariants = VariantProps<typeof alertVariants>;

@Directive({
  selector: 'hlm-alert,[hlmAlert]',
  host: {
    'data-slot': 'alert',
    role: 'alert',
  },
})
export class HlmAlert {
  public readonly variant = input<AlertVariants['variant']>('default');

  constructor() {
    classes(() => alertVariants({ variant: this.variant() }));
  }
}
